// extracted by mini-css-extract-plugin
export var card = "_li-5";
export var cardSelected = "_li-4";
export var image = "_li-3";
export var modal = "_li-0";
export var modalContent = "_li-1";
export var table = "_li-2";